<template>
  <span>{{ formattedDateTime }}</span>
</template>

<script>
  import { formatDateTime } from "@/components/mixins/formatDateTime"

  export default {
    mixins: [formatDateTime],
    props: {
      dateString: {
        type: String,
        default: ""
      }
    },
    computed: {
      formattedDateTime () {
        return this.formatDateTime(this.dateString)
      }
    }
  }
</script>
